
import { useEffect, useState, useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { NewOnboardingModal } from "./onboarding/NewOnboardingModal";
import { useOnboardingProgress } from "@/hooks/useOnboardingProgress";

interface ProfileCompletionCheckProps {
  children: React.ReactNode;
}

const ProfileCompletionCheck = ({ children }: ProfileCompletionCheckProps) => {
  const { user, isLoading } = useAuth();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const { progress, isLoading: isLoadingProgress } = useOnboardingProgress();
  const [isCheckingProfile, setIsCheckingProfile] = useState(true);
  const location = useLocation();

  // Memoizar valores para evitar re-renders desnecessários
  const shouldShowOnboarding = useMemo(() => {
    return user && (!progress || !progress.completed_at);
  }, [user?.id, progress?.completed_at]);

  useEffect(() => {
    if (!isLoading && !isLoadingProgress) {
      setIsCheckingProfile(false);
      setShowOnboarding(shouldShowOnboarding);
    }
  }, [isLoading, isLoadingProgress, shouldShowOnboarding]);

  // Show nothing while checking authentication or progress
  if (isLoading || isLoadingProgress || isCheckingProfile) {
    return null;
  }

  // If not authenticated, this will be handled by the ProtectedRoute component
  if (!user) {
    return <>{children}</>;
  }

  // Render children with onboarding modal
  return (
    <>
      {children}
      <NewOnboardingModal 
        isOpen={showOnboarding} 
        onClose={() => setShowOnboarding(false)} 
      />
    </>
  );
};

export default ProfileCompletionCheck;
